import type { Role } from "@dishour/shared";
import { NavLink } from "react-router";

type NavItem = { to: string; label: string };

export const ADMIN_ITEMS: NavItem[] = [
  { to: "/admin/orgs", label: "조직" },
  { to: "/admin/skus", label: "품목" },
  { to: "/admin/rounds", label: "라운드" },
  { to: "/admin/invites", label: "초대" },
];

const RESTAURANT_ITEMS: NavItem[] = [
  { to: "/rounds", label: "공동구매" },
  { to: "/deals", label: "특가" },
  { to: "/orders", label: "주문" },
  { to: "/invoices", label: "청구서" },
];

const SUPPLIER_ITEMS: NavItem[] = [
  { to: "/supplier", label: "취합 현황" },
  { to: "/supplier/deals", label: "특가" },
  { to: "/supplier/skus", label: "카탈로그" },
  { to: "/supplier/invoices", label: "청구서" },
];

const ITEMS_BY_ROLE: Partial<Record<Role, NavItem[]>> = {
  admin: ADMIN_ITEMS,
  restaurant: RESTAURANT_ITEMS,
  supplier: SUPPLIER_ITEMS,
};

export function hasNavItems(role: Role): boolean {
  return (ITEMS_BY_ROLE[role]?.length ?? 0) > 0;
}

/**
 * Fixed to the bottom so it's reachable one-handed. Each tab spans an equal share of the
 * 375px-wide screen, which keeps every tap target comfortably above the ~44px minimum.
 */
export function BottomNav({ role }: { role: Role }) {
  const items = ITEMS_BY_ROLE[role];
  if (!items || items.length === 0) return null;

  return (
    <nav className="fixed inset-x-0 bottom-0 z-10 border-t border-stone-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-screen-sm">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            // "/supplier" is a prefix of "/supplier/deals" — without `end`, both tabs would
            // light up while on the deals screen.
            end
            className={({ isActive }) =>
              `flex-1 py-3 text-center text-sm font-medium ${isActive ? "text-brand-700" : "text-stone-400"}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
